var map = {
	"./Integridade.png": "0d87",
	"./Zelo.png": "4806",
	"./carol-couto.png": "99c8",
	"./clever-hero.png": "c21d",
	"./clever-together-blue.png": "33ed",
	"./gold-trigger.svg": "847a",
	"./marcelo-colleoni.png": "a100",
	"./papo-clever.png": "1d88",
	"./people.png": "1737"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ee66";